import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, scale: 0.95 },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
    },
  },
};

const Gallery = () => {
  return (
    <section className="py-32 bg-black">
      {/* Atatürk Sözü */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-32"
      >
        <div className="relative">
          <div className="text-center">
            <blockquote className="text-3xl md:text-4xl lg:text-5xl italic text-white [text-shadow:_0_2px_4px_rgb(0_0_0_/_60%)]">
              "Kalpleri kırmak değil, kalpleri kazanmak isterim."
            </blockquote>
            <div className="mt-8 flex justify-end">
              <motion.img
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3, duration: 0.5 }}
                src="/images/ataturk-imza.png"
                alt="Atatürk İmza"
                className="h-20 text-white"
              />
            </div>
          </div>
        </div>
      </motion.div>

      {/* Galeri */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-4xl sm:text-5xl font-bold text-center text-white mb-20 tracking-wide"
        >
          Galeri
        </motion.h2>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8"
        >
          {/* Fotoğraf slotları */}
          <motion.div
            variants={item}
            className="group aspect-[4/3] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500"
          >
            <div className="w-full h-full bg-gray-900 overflow-hidden">
              <img
                src="/gallery/photo1.jpeg"
                alt="Kolektif Oluşum Etkinlik"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            variants={item}
            className="group aspect-[4/3] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500"
          >
            <div className="w-full h-full bg-gray-900 overflow-hidden">
              <img
                src="/gallery/photo2.jpeg"
                alt="Kolektif Oluşum Etkinlik"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            variants={item}
            className="group aspect-[4/3] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500"
          >
            <div className="w-full h-full bg-gray-900 overflow-hidden">
              <img
                src="/gallery/photo3.jpeg"
                alt="Kolektif Oluşum Etkinlik"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            variants={item}
            className="group aspect-[4/3] rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500"
          >
            <div className="w-full h-full bg-gray-900 overflow-hidden">
              <img
                src="/gallery/photo4.jpeg"
                alt="Kolektif Oluşum Etkinlik"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </motion.div>

        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="mt-20 text-center"
        >
          <a
            href="/galeri"
            className="inline-flex items-center px-10 py-5 text-lg rounded-2xl text-white bg-blue-600 hover:bg-blue-700 transform hover:-translate-y-1 transition-all duration-300 shadow-lg hover:shadow-blue-500/25"
          >
            Tüm Fotoğrafları Gör
            <svg
              className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-200"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </a>
        </motion.div> */}
      </div>
    </section>
  );
};

export default Gallery;
